import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, captureFbclid } from './trackEvent';

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    captureFbclid();
    trackPageView();
  }, [location.pathname]);

  return null;
}
